import { Center, Flex, Spinner } from '@chakra-ui/react'
import { useProfile } from '../../../../contexts/user/ProfileContext'
import { LabQuickview } from './LabQuickview'

export const ProfileLabsView = () => {
  const { userId: patientId, assessmentId } = useProfile()

  if (!patientId)
    return (
      <Center w="100%" h="100%">
        <Spinner />
      </Center>
    )

  return (
    <Flex w="100%" h="100%" flexFlow="column" gap={3} p={3} overflowY="auto">
      <LabQuickview assessmentId={assessmentId} patientId={patientId} />
    </Flex>
  )
}
